import { buildSchema, buildProperty, ExportMappingFunction } from "@camberi/firecms";

/**
 * This is a schema that is generated without passing an explicit type,
 * but it is inferred correctly since we are using `buildProperty` in each property
 */
export const splashScreenSchema = buildSchema({
    name: "Splash Screen",
    properties: {
        title: buildProperty({
            title: "Title",
            validation: { required: true },
            dataType: "string"
        }),
        image: buildProperty({
            title: "Image",
            dataType: "reference",
            path: "media",
            previewProperties: ["mediaUrl"],
            validation: { required: true },
        }),
        order: {
            title: "Order",
            dataType: "number",
            validation: { required: true },
        },
        description: {
            title: "description",
            dataType: "string",
            config: {
                markdown: true
            },
        },
        category: buildProperty({
            title: "Category",
            validation: { required: true },
            dataType: "string",
            columnWidth: 140,
            config: {
                enumValues: {
                    "appFeatures": "App Features",
                    Nutrition: "Nutrition",
                    "About Me": "About Me",
                    Transformation: "Transformation",
                }
            }
        }),
        createdAt: {
            title: "createdAt",
            dataType: "timestamp",
            validation: { required: true },
        },
       
      
       
        
    },
    defaultValues: {
        // status: "draft",
        // order: 0
    }
});

/**
 * Sample field that will be added to the export
 */
export const sampleAdditionalExportColumn: ExportMappingFunction = {
    key: "extra",
    builder: async ({ entity }) => {
        await new Promise(resolve => setTimeout(resolve, 100));
        return "Additional exported value " + entity.id;
    }
};
